import { render, staticRenderFns } from "./OsTargetProfileForm.vue?vue&type=template&id=788f5e0c&scoped=true"
import script from "./OsTargetProfileForm.vue?vue&type=script&lang=ts"
export * from "./OsTargetProfileForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "788f5e0c",
  null
  
)

export default component.exports